export default "__VITE_ASSET__BpFQkyfD__"